export default {
  setHomework: '书籍列表',
  login: '登录',
	publishHomeWork:'书本目录',
	home:'作业',
	personMsg:'个人中心',
	systemMessages:'系统消息',
	readWords: '选择单词',
	selectListenSpeak: '选择听说模考大题',
	selectText:'选择段落',
	class:'班级管理',
	checkOnlinePaper:'在线作答详情',
	selectOnlinePaper:'在线作答预览',
	checkTSMK:'听说模考详情',
	ranks:'单个作业排名',
	rankWork:'总排名',
  register:'注册',
  ForgotPwd:'忘记密码',
  schoolMsg:'校讯通',
  managePaper:'管理试卷',
  publishBooks:'布置作业',
  selectObject:'布置对象',
  watchSinglePaper: '错题统计',
  watchStudc: '查看单词详情',
  watchStukw: '查看课文详情'
}



// WEBPACK FOOTER //
// ./src/seo.js